module.exports = __webpack_public_path__ + "static/media/wever.f910ddea.png";